module.exports = __webpack_public_path__ + "img/carPerson.9d7cc0ea.png";